import { render, staticRenderFns } from "./Tab2.vue?vue&type=template&id=0633a434&scoped=true&"
import script from "./Tab2.vue?vue&type=script&lang=js&"
export * from "./Tab2.vue?vue&type=script&lang=js&"
import style0 from "./Tab2.vue?vue&type=style&index=0&id=0633a434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633a434",
  null
  
)

export default component.exports